import { toast } from 'react-toastify';
import { TOAST_TYPES } from '@constants';

export const defaultToastOptions = {
    autoClose: 2000,
    hideProgressBar: true
};

export const toastNotification = (type, message, options = defaultToastOptions) => {
    if (!TOAST_TYPES[type]) {
        console.warn(`${type} is not a valid toast option`);
    } else {
        // Returns the Id of this particular toast
        return toast[type](message, options);
    }
};

export const dismissToast = (toastId = undefined) => {
    // Default is to dismiss all if no argument is passed
    toast.dismiss(toastId);
};

export const clearToastQueue = () => {
    toast.clearWaitingQueue();
};
